import { Apis } from "../../../lib/Apis";

export const useOrders = () => {
    const getOrderByOrderId = async (orderId, setOrderData) => {
        try {
            const response = await Apis.getOrderByOrderId(orderId);
            // Handle new response structure: { status: true, orderData: {...} }
            // The response might be wrapped in response.data or directly accessible
            const orderData = response.data?.orderData || response.orderData || response.data;
            setOrderData(orderData);
        } catch (error) {
            console.error("Error fetching order data:", error);
        }
    };
    return { getOrderByOrderId };
}